<button mat-raised-button *appRole="['TiposAjusteContrato.Crear']" color="primary" [routerLink]="['/iposajustecontrato']">
  <mat-icon>add</mat-icon>
  Nuevo tipo bonificación
</button>
